import { AuthService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { TCall, TCallOptions } from 'app/queries/types/TCall';
import type { authKeys } from './authKeys';

type TParams = QueryFunctionContext<ReturnType<typeof authKeys.me> | ReturnType<typeof authKeys.desktopMe>>;

export const createFetchAuthMeQueryFn =
  (call: TCall, options?: TCallOptions) =>
  ({ signal }: TParams) =>
    call(() => cancelOnSignal(AuthService.me(), signal), options);
